export default function XSD_ComplexElements() {
  return (
    <div>
      <h1>XSD_ComplexElements</h1>
      <p>This is the XSD_ComplexElements component.</p>
    </div>
  );
}